// Reducer for trending topics actions
import { saveAs } from 'file-saver'

import * as ActionTypes from '../constants/action_types'
import { DefaultState } from './DefaultState'
import * as ReducerUtils from './utils'

const DefaultTrendingExportState = {
  ...DefaultState
}

const initialState = {
  selectedDate: null,
  twitter: DefaultState,
  youtube: DefaultState,
  trendingDate: null,
  export: DefaultTrendingExportState
}

export const trendingTopicsExport = (state = DefaultTrendingExportState, action) => {
  switch (action.type) {
    case ActionTypes.REQUEST_TRENDING_TOPICS_EXPORT:
      return {
        ...state,
        isFetching: true
      }
    case ActionTypes.RECEIVE_TRENDING_TOPICS_EXPORT:
      saveAs(action.response, action.filename)
      return {
        ...state,
        isFetching: false,
        lastUpdated: action.receivedAt
      }
    case ActionTypes.REQUEST_TRENDING_TOPICS_EXPORT_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.error,
        lastUpdated: action.receivedAt
      }
    default:
      return state
  }
}

export const twitterTrends = ReducerUtils.makeSingleObjectReducer({
  defaultState: DefaultState,
  actionRequest: ActionTypes.REQUEST_TRENDING_TOPICS_TWITTER,
  actionFailure: ActionTypes.REQUEST_TRENDING_TOPICS_TWITTER_FAILURE,
  actionReceive: ActionTypes.RECEIVE_TRENDING_TOPICS_TWITTER,
  actionInvalidate: ActionTypes.INVALIDATE_TRENDING_TOPICS_TWITTER
})

export const youtubeTrends = ReducerUtils.makeSingleObjectReducer({
  defaultState: DefaultState,
  actionRequest: ActionTypes.REQUEST_TRENDING_TOPICS_YOUTUBE,
  actionFailure: ActionTypes.REQUEST_TRENDING_TOPICS_YOUTUBE_FAILURE,
  actionReceive: ActionTypes.RECEIVE_TRENDING_TOPICS_YOUTUBE,
  actionInvalidate: ActionTypes.INVALIDATE_TRENDING_TOPICS_YOUTUBE
})

export const tiktokTrends = ReducerUtils.makeSingleObjectReducer({
  defaultState: DefaultState,
  actionRequest: ActionTypes.REQUEST_TRENDING_TOPICS_TIKTOK,
  actionFailure: ActionTypes.REQUEST_TRENDING_TOPICS_TIKTOK_FAILURE,
  actionReceive: ActionTypes.RECEIVE_TRENDING_TOPICS_TIKTOK,
  actionInvalidate: ActionTypes.INVALIDATE_TRENDING_TOPICS_TIKTOK
})

export const instagramTrends = ReducerUtils.makeSingleObjectReducer({
  defaultState: DefaultState,
  actionRequest: ActionTypes.REQUEST_TRENDING_TOPICS_INSTAGRAM,
  actionFailure: ActionTypes.REQUEST_TRENDING_TOPICS_INSTAGRAM_FAILURE,
  actionReceive: ActionTypes.RECEIVE_TRENDING_TOPICS_INSTAGRAM,
  actionInvalidate: ActionTypes.INVALIDATE_TRENDING_TOPICS_INSTAGRAM
})

export const trendingDate = ReducerUtils.makeSingleObjectReducer({
  defaultState: DefaultState,
  actionRequest: ActionTypes.REQUEST_TRENDING_TOPICS_DATE,
  actionFailure: ActionTypes.REQUEST_TRENDING_TOPICS_DATE_FAILURE,
  actionReceive: ActionTypes.RECEIVE_TRENDING_TOPICS_DATE,
  actionInvalidate: ActionTypes.INVALIDATE_TRENDING_TOPICS_DATE
})

export const trendingTopics = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.REQUEST_TRENDING_TOPICS_TWITTER:
    case ActionTypes.RECEIVE_TRENDING_TOPICS_TWITTER:
    case ActionTypes.REQUEST_TRENDING_TOPICS_TWITTER_FAILURE:
    case ActionTypes.INVALIDATE_TRENDING_TOPICS_TWITTER:
      return {
        ...state,
        twitter: twitterTrends(state.details, action)
      }
    case ActionTypes.REQUEST_TRENDING_TOPICS_YOUTUBE:
    case ActionTypes.RECEIVE_TRENDING_TOPICS_YOUTUBE:
    case ActionTypes.REQUEST_TRENDING_TOPICS_YOUTUBE_FAILURE:
    case ActionTypes.INVALIDATE_TRENDING_TOPICS_YOUTUBE:
      return {
        ...state,
        youtube: youtubeTrends(state.details, action)
      }
    case ActionTypes.REQUEST_TRENDING_TOPICS_TIKTOK:
    case ActionTypes.RECEIVE_TRENDING_TOPICS_TIKTOK:
    case ActionTypes.REQUEST_TRENDING_TOPICS_TIKTOK_FAILURE:
    case ActionTypes.INVALIDATE_TRENDING_TOPICS_TIKTOK:
      return {
        ...state,
        tiktok: tiktokTrends(state.details, action)
      }
    case ActionTypes.REQUEST_TRENDING_TOPICS_INSTAGRAM:
    case ActionTypes.RECEIVE_TRENDING_TOPICS_INSTAGRAM:
    case ActionTypes.REQUEST_TRENDING_TOPICS_INSTAGRAM_FAILURE:
    case ActionTypes.INVALIDATE_TRENDING_TOPICS_INSTAGRAM:
      return {
        ...state,
        instagram: instagramTrends(state.details, action)
      }
    case ActionTypes.REQUEST_TRENDING_TOPICS_DATE:
    case ActionTypes.RECEIVE_TRENDING_TOPICS_DATE:
    case ActionTypes.REQUEST_TRENDING_TOPICS_DATE_FAILURE:
    case ActionTypes.INVALIDATE_TRENDING_TOPICS_DATE:
      return {
        ...state,
        trendingDate: trendingDate(state.details, action)
      }
    case ActionTypes.SET_TRENDING_TOPICS_DATE:
      return {
        ...state,
        selectedDate: action.date
      }
    case ActionTypes.REQUEST_TRENDING_TOPICS_EXPORT:
    case ActionTypes.RECEIVE_TRENDING_TOPICS_EXPORT:
    case ActionTypes.REQUEST_TRENDING_TOPICS_EXPORT_FAILURE:
      return {
        ...state,
        export: trendingTopicsExport(state.export, action)
      }
    default:
      return state
  }
}